export default __webpack_public_path__ + "static/media/photo--lg--11.f89bd001.jpg";